window.productCardsFunc = function productCardsFunc() {
  if (document.querySelector('.product-card')) {
    const productCardsArr = document.querySelectorAll('.product-card');

    productCardsArr.forEach((card) => {
      if (!card.classList.contains('is-init')) {
        card.classList.add('is-init');

        const counterBlock = card.querySelector('.product-card__btn-counter');
        const btn = card.querySelector('.btn-second');
        const btnIcon = counterBlock.querySelector('.btn-icon');
        const input = counterBlock.querySelector('input');
        const favoriteBtn = card.querySelector('.product-card__favorite');
        const favoriteBtnIcon = card.querySelector('.product-card__favorite i');

        if (input && input.value !== '') {
          if (counterBlock) {
            counterBlock.classList.add('active');
            card.classList.add('is-open-counter');
          }
        }

        if (btn) {
          btn.addEventListener('click', () => {
            // console.log(input.value);

            if (counterBlock) {
              counterBlock.classList.add('active');
              card.classList.add('is-open-counter');
            }

            if ((input && input.value < 1) || (input && input.value === '')) {
              input.value = '0';
              // console.log(input.value);
              input.stepUp();
            }
          });
        }

        if (btnIcon) {
          btnIcon.addEventListener('click', () => {
            // console.log(input.value);

            if (counterBlock) {
              counterBlock.classList.add('active');
              card.classList.add('is-open-counter');
            }

            if ((input && input.value < 1) || (input && input.value === '')) {
              input.value = '0';
              // console.log(input.value);
              input.stepUp();
            }
          });
        }

        if (favoriteBtn) {
          favoriteBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (!document.querySelector('#site').classList.contains('not-authorized')) {
              if (favoriteBtn.classList.contains('active')) {
                favoriteBtn.classList.remove('active');
                favoriteBtnIcon.classList.remove('icon-heart-fill');
                favoriteBtnIcon.classList.add('icon-heart');
              } else {
                favoriteBtn.classList.add('active');
                favoriteBtnIcon.classList.remove('icon-heart');
                favoriteBtnIcon.classList.add('icon-heart-fill');
              }
            }
          });
        }
      }
    });

    setTimeout(function () {
      const productCardsTitlesArr = document.querySelectorAll(
        '.product-card__title'
      );

      if (productCardsTitlesArr.length > 0) {
        let maxHeight = 0;
        productCardsTitlesArr.forEach((title) => {
          const height = title.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });

        productCardsTitlesArr.forEach((title) => {
          title.style.minHeight = `${maxHeight}px`;
        });
      }
    }, 50);
  }
};

productCardsFunc();

const productRecipeContainer = document.querySelector(
  '.product-section__container'
);
if (productRecipeContainer) {
  const productInstructionsEl = document.querySelector(
    '.product-section__instruction'
  );
  if (productInstructionsEl) {
    const productInstructionsCountsArr =
      productRecipeContainer.querySelectorAll(
        '.product-section__instruction-count'
      );
    productInstructionsCountsArr.forEach((count, i) => {
      count.textContent = `${i + 1}`;
    });
  }
}

window.relatedCardsFunc = function relatedCardsFunc() {
  if (document.querySelector('.product-card')) {
    const cards = document.querySelectorAll('.product-card');
    cards.forEach((card) => {
      const relatedContent = card.querySelector('.product-card__related');

      if (relatedContent) {
        card.classList.add('is-related-products');
      } else {
        card.classList.remove('is-related-products');
      }
    });
  }
};

window.relatedBtnAdd = function relatedBtnAdd(id) {
  const btn = document.getElementById(id);
  btn.classList.add('is-added');
}
window.relatedBtnRemove = function relatedBtnRemove(id) {
  const btn = document.getElementById(id);
  btn.classList.remove('is-added');
}
